'use client';
import React from 'react';
import { Box } from '@mui/material';
import cn from './style.module.scss';
interface CustomBackgroundProps {
  customClass?: string;
  bgImage?: string;
  bgXs?: string;
  bgMd?: string;
  bgLg?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
}

export default function CustomBackground({
  customClass = '',
  bgImage,
  bgXs,
  bgMd,
  bgLg,
  backgroundColor,
  children,
}: CustomBackgroundProps) {
  const responsiveBg: any = {};
  if (bgImage) responsiveBg.xs = `url(${bgImage})`;
  if (bgXs) responsiveBg.xs = `url(${bgXs})`;
  if (bgMd) responsiveBg.md = `url(${bgMd})`;
  if (bgLg) responsiveBg.lg = `url(${bgLg})`;

  return (
    <Box
      className={`${cn.customBackgroundWrapper} ${customClass}`}
      sx={{
        backgroundColor: backgroundColor || 'transparent',
        ...(Object.keys(responsiveBg).length > 0 && {
          backgroundImage: responsiveBg,
        }),
      }}
    >
      {children}
    </Box>
  );
}
